<div *withPermissions="let allow of ['CanManageGoogleAccess']" class="card">
  <div class="card-header">
    Customer Contact
  </div>
  <div [loadingOverlay]="isLoading" class="card-body">
    <div class="card card-body bg-light">
      <div class="row">
        <div class="col-md-12">
          <compose Selector="app-components-managecustomer-customercontactpreferences" [ActivateOptions]="{
                       customerId: customer.CustomerId
                    }"></compose>
        </div>
      </div>
    </div>
    <hr />
    <app-table [items]="contactUsers">
      <ng-template #tableHeader>
        <tr>
          <th style="width: 40px"></th>
          <th style="width: 75px;">Primary</th>
          <th sort field="FullName()">Name</th>
          <th sort field="Username()">Email</th>
          <th>Phone</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template #tableBody let-customerUser>
        <tr>
          <td>
            <a (click)="editUser(customerUser)" title="Edit User" class="cursor-pointer">
              <i class="fas fa-pen-to-square fa-lg text-primary"></i>
            </a>
          </td>
          <td class="text-center">
            <i *ngIf="customerUser.IsPrimary" class="fas fa-star text-warning"></i>
          </td>
          <td>
            <span>{{customerUser.FirstName + ' ' + customerUser.LastName}}</span>
          </td>
          <td>
            <ng-container *ngIf="!(customerUser.CustomerUserId === 0)">
              <a [attr.href]="'mailto:' + customerUser.Username">
                <span>{{customerUser.Username}}</span>
              </a>
            </ng-container>
            <ng-container *ngIf="customerUser.EmailRecipientType">
              <span class="badge rounded-pill bg-primary float-end" style="font-size: 0.8rem;">
                {{customerUser.EmailRecipientType | emailRecipientType}}
              </span>
            </ng-container>
          </td>
          <td>
            <shared-components-clicktocall *ngIf="customerUser.CanContact" [Phone]="customerUser.PrimaryPhoneNumber"
              [CountryCode]="countryAbbreviation"></shared-components-clicktocall>
            <i *ngIf="customerUser.CanReceiveTextMessages && customerUser.PrimaryPhoneNumber"
              class="fas fa-mobile-alt float-end text-primary" title="Can Receive Text Messages"
              style="font-size:1.2em"></i>
          </td>
          <td>
            <ng-container *ngIf="!(customerUser.CustomerUserId === 0)">
              <ng-container *ngIf="!customerUser.IsPrimary">
                <a (click)="makePrimaryContact(customerUser)"
                  title="Change to Primary Contact" class="cursor-pointer">
                  <i class="fa fa-star-half-stroke fa-2x ms-2"></i>
                </a>
                <a (click)="deleteUser(customerUser)" title="Delete User" class="cursor-pointer">
                  <i class="fas fa-trash-alt fa-2x text-danger float-end"></i>
                </a>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </app-table>
    <div>
      <button (click)="addUser()" class="btn btn-success float-end">
        <i class="fa fa-plus"></i>
        Add New User
      </button>
    </div>
  </div>
  <ng-container *ngIf="footerTemplate">
    <ng-template-outlet [ngTemplateOutlet]="footerTemplate"></ng-template-outlet>
  </ng-container>
</div>